export default "__VITE_ASSET__CNWWfrpm__"